var baseToString = require('./_baseToString');

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;



/*****************
 ** WEBPACK FOOTER
 ** ../~/lodash/toString.js
 ** module id = 389
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/lodash/toString.js
 ** module id = 389
 ** module chunks = 1
 **/